import {
	StyleSheet,
	View,
	Text,
	TouchableOpacity,
	SafeAreaView,
} from "react-native";
import React from "react";

import { Ionicons } from "@expo/vector-icons";
import { useTheme } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";

const TermsOfServiceHeader = () => {
	const { colors } = useTheme();
	const navigation = useNavigation();
	return (
		<SafeAreaView style={{ backgroundColor: "#40b8b8" }}>
			<TouchableOpacity style={styles.root} onPress={navigation.goBack}>
				<Ionicons name="chevron-back" size={24} color={colors.primary} />
				<View style={styles.container}>
					<Text style={styles.text}>Termos de Uso</Text>
				</View>
			</TouchableOpacity>
		</SafeAreaView>
	);
};

export default TermsOfServiceHeader;

const styles = StyleSheet.create({
	root: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#fff",
		height: 60,
		paddingLeft: 11,
		paddingVertical: 12,
	},
	container: {
		alignItems: "center",
		width: "100%",
	},
	text: {
		flexDirection: "row",
		fontWeight: "600",
		alignSelf: "center",
		fontSize: 18,
		marginLeft: "-12%",
	},
});
